import React from "react";
import { motion } from "framer-motion/dist/framer-motion";
import { useHistory } from "react-router-dom";
import { Container } from "./styles";
import logo from "../../assets/logos/icon_only_small-removebg.png";
import "./contractRegistration.css";

const ContractPaymentCancel = () => {
  const history = useHistory();
  return (
    <Container>
      <div>
        <div
          className="logo"
          onClick={() => {
            history.push("/login");
          }}
        >
          <img alt="logo" src={logo} />
          <span style={{ color: "rgb(26, 166, 155)" }}>Chapperone</span>
        </div>
        <h1>Something wents wrong with payments</h1>
        <p style={{ fontSize: "20px", textAlign: "center" }}>
          Please try again or contact with Us
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "30px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="red"
            // viewBox="0 0 24 24"
            viewBox="0 0 16 16"
            // strokeWidth={0}
            // stroke="red"
          >
            <motion.path
              // strokeLinecap="round"
              // strokeLinejoin="round"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.5 }}
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
              fill="red"
            />
          </svg>
        </div>
      </div>
    </Container>
  );
};
export default ContractPaymentCancel;
